import PropTypes from "prop-types"
import NineBoxGridDrilldownScorePairShape from "./NineBoxGridDrilldownScorePairShape"

const boxSuccessor = {
  employeeId: PropTypes.number,
  fullName: PropTypes.string.isRequired,
}

const NineBoxGridBoxEmployee = {
  nextJob: PropTypes.string,
  nextLocation: PropTypes.string,
  potentialScores: PropTypes.arrayOf(PropTypes.shape(NineBoxGridDrilldownScorePairShape))
    .isRequired,
  performanceScores: PropTypes.arrayOf(PropTypes.shape(NineBoxGridDrilldownScorePairShape))
    .isRequired,
  engagementScores: PropTypes.arrayOf(PropTypes.shape(NineBoxGridDrilldownScorePairShape))
    .isRequired,
  successors: PropTypes.arrayOf(PropTypes.shape(boxSuccessor)).isRequired,
  employeeWorkflowdId: PropTypes.number,
  riskLevel: PropTypes.number.isRequired,
  dateGenerated: PropTypes.string.isRequired,
  employeeId: PropTypes.number.isRequired,
  externalReference: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  locationFullName: PropTypes.string.isRequired,
  appraisalLevelTranslationKeyId: PropTypes.number,
  jobTitleTranslationKeyId: PropTypes.number,
  managerFirstName: PropTypes.string.isRequired,
  managerLastName: PropTypes.string.isRequired,
}

export default NineBoxGridBoxEmployee



// WEBPACK FOOTER //
// ./src/state/shapes/NineBoxGridBoxEmployee.js